import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from './AuthProvider';
import { AUDIENCE_HOME, AUDIENCE_LOGIN, type Audience } from './roles';

/** Wraps an audience's routes: anonymous -> its login, wrong audience -> its own home. */
export function AuthGuard({ audience, children }: { audience: Audience; children: ReactNode }) {
  const { session } = useAuth();
  const location = useLocation();

  if (!session) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to={AUDIENCE_LOGIN[audience]} replace state={{ from }} />;
  }
  if (session.audience !== audience) {
    return <Navigate to={AUDIENCE_HOME[session.audience]} replace />;
  }
  return <>{children}</>;
}
